import { render } from "./LanguageSwitcher.vue?vue&type=template&id=879ba80e"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=879ba80e&lang=scss"
script.render = render

export default script